module.exports = __webpack_public_path__ + "static/media/iconSeguroPlus.pictogram.934d969b.svg";